import { useQuery, ApolloError } from '@apollo/client';
import useTranslation from 'next-translate/useTranslation';
import { HouseQueryData, HouseQueryNode } from 'prismic/graphQLQueries/house.types';
import { houseQuery } from 'prismic/graphQLQueries/house';
import { useLinkResolver } from 'prismic/helpers/useLinkResolver';
import { ModalContent } from './ModalContent.partial';
import { ModalHouseProps } from './ModalHouse.types';
import {
  ModalStyled,
  LoadingStyled,
  ModalHeaderStyled,
  ModalCloseStyled,
  IconCloseStyled,
  HeaderHeadlinesStyled,
} from './ModalHouse.styles';

const getHouseData = (data: HouseQueryData): HouseQueryNode | undefined => {
  if (data?.allGebaeudes?.edges && data?.allGebaeudes?.edges.length > 0) {
    return data.allGebaeudes.edges[0].node;
  }
  return undefined;
};

export const ModalHouse: React.FC<ModalHouseProps> = ({
  className,
  dataMap,
  houseNr,
  onCloseCallback,
}) => {
  const { locale } = useLinkResolver();

  const keyHouseMap = `${locale}_${houseNr}`;
  const storedData = dataMap && dataMap.get(keyHouseMap);

  const { t } = useTranslation('common');

  let houseData: HouseQueryNode | undefined;
  let _loading = false;
  let _error: ApolloError | undefined;

  if (storedData) {
    houseData = storedData;
  }

  const { data, loading, error } = useQuery<HouseQueryData>(houseQuery, {
    skip: !!storedData,
    variables: {
      lang: locale,
      house_nr: parseInt(houseNr, 10),
    },
  });

  _loading = loading;
  _error = error;

  // Store house data in a Map, to avoid requests
  if (data) {
    if (dataMap) {
      const mappedHouseData = getHouseData(data);
      if (mappedHouseData) {
        dataMap.set(keyHouseMap, mappedHouseData);
      }
    }
    houseData = getHouseData(data);
  }

  return (
    <ModalStyled className={className}>
      {_loading && <LoadingStyled />}

      {_error && <p>${_error.message}</p>}

      {houseData && <ModalContent data={houseData} onCloseCallback={onCloseCallback} />}
      {!houseData && !_loading && (
        <>
          <ModalHeaderStyled>
            <HeaderHeadlinesStyled>
              <div>{t('noData')}</div>
            </HeaderHeadlinesStyled>
            <ModalCloseStyled onClick={onCloseCallback}>
              <IconCloseStyled name="CLOSE" />
            </ModalCloseStyled>
          </ModalHeaderStyled>
        </>
      )}
    </ModalStyled>
  );
};
